import React from 'react';

import './styles/@theme';

type GameTileImageMobileProps = {
    logoUrl: string;
    backgroundUrl?: string;
    customBackgroundColor?: string;
};

export const GameTileImageMobile = ({ logoUrl, backgroundUrl, customBackgroundColor }: GameTileImageMobileProps) => {
    return (
        <div className="image-container">
            <div className="game-tile__image--mobile" style={{ backgroundColor: customBackgroundColor }}>
                <img className="tile-background" src={backgroundUrl} alt="" loading="lazy" />
                <img className="tile-logo" src={logoUrl} alt={logoUrl} loading="lazy" />
            </div>
        </div>
    );
};
